// Module
var code = `<div class="{{#if noArrowCB}}cash{{else}}js-quantity-numeric{{/if}}"
     style="{{>visibility}}{{#if isPosAbsolute}}position: absolute; {{>position}}{{/if}}"
     {{>visualparameters}}>
  
    <terceraNumeric value="{{.value}}"
                    minValue="{{.minValue}}"
                    maxValue="{{.maxValue}}"
                    step="{{.step}}"
                    incrementCoefficient="{{.incrementCoefficient}}"
                    decimalPrecision="{{.decimalPrecision}}"
                    errorText="{{.errorText}}"
                    enabled="{{.enabled}}"
                    visible="{{.visible}}"
                    focused="{{.focused}}"
                    hasError="{{.hasError}}"
                    tradingNumeric="true"
                    allowMinus="false"
                    showArrows="{{.showArrows}}"
                    name="QTYNumeric"
                    tooltip="{{.tooltip}}"
                    valueLessMinLocalKey="{{.valueLessMinLocalKey}}"
                    valueGreaterMaxLocalKey="{{.valueGreaterMaxLocalKey}}"
                    validationStateInfo="{{.validationStateInfo}}"
                    customCSSClass="{{customCSSClass}}" 
                    rightAlignedText="{{assetNameForCash}}" />

    {{#if noArrowCB === false}}
    <terceraButton name="ArrowDown" terceraButtonStyle="js-popup-button{{#if isQuantityMenuOpen}} active{{/if}}" SVG="true" enabled="{{.enabled}}" on-btnClick="openQuantityMenu" />
    {{/if}}
</div>`;
// Exports
export default code;